import { hasPermission } from "byzantine/src/dbbl/businessLogic/modules/permissions/utils";
import { BUSINESS } from "byzantine/src/dbbl/businessLogic/modules/permissions/constants";

import { useCurrentUser } from "../../../../components/contexts/CurrentUserContext";

export const useCanWriteReceipts = (): boolean => {
  const { currentUser } = useCurrentUser();
  if (!currentUser) return false;
  // Consumers have no role tiers: any account user can attach and unlink.
  if (!currentUser.isBusiness()) return true;
  return hasPermission(
    currentUser.business_permissions,
    BUSINESS.WRITE.TRANSACTION
  );
};

export default useCanWriteReceipts;
